'use client';
import { jsx } from 'react/jsx-runtime';
import SvgChevronLeft from '../../assets/icons/chevron-left.svg.js';

const IconChevronLeft = ({ ...props }) => {
    return jsx(SvgChevronLeft, { ...props });
};

export { IconChevronLeft };
//# sourceMappingURL=icon-chevron-left.js.map
